import React from 'react';
import { Layout, Button } from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import { ERROR_SCREEN } from '../copyText/errorScreen';
import '../assets/dashboard.scss';

/**
 * ErrorScreen – A full-page error state component following DLS v7 patterns.
 *
 * Displayed when:
 * - The Dashboard API request fails
 * - The Get VRP Details API request fails
 *
 * @param {object} props
 * @param {function} [props.onRetry] - Callback fired when the user clicks "Try again".
 *                                     If omitted, the button reloads the page.
 */
function ErrorScreen() {
  return (
    <Layout variant="card" className="row">
      <div className="col-md-4 col-md-offset-4 text-align-center pad-t">
        <IconWarning
          isFilled={false}
          title={ERROR_SCREEN.ARIA_ICON_TITLE}
          titleId="error-screen-icon"
          size="xl"
          color="critical"
        />
      </div>

      <div className="col-md-4 col-md-offset-4">
        <p className="text-align-center pad-t">{ERROR_SCREEN.DESCRIPTION}</p>
      </div>
      <div className="col-md-6 col-md-offset-3 margin-b">
        <p className="text-align-center pad-tb">
          {ERROR_SCREEN.SUPPORT_TEXT}
          <strong className="color-text-brand"><a className="color-text-brand text-underline-none" href={ERROR_SCREEN.SUPPORT_LINK_URL}>{ERROR_SCREEN.SUPPORT_LINK_TEXT}</a></strong>
        </p>
      </div>
      <div className="col-md-4 col-md-offset-4 text-align-center margin-b">
        <Button
          variant="primary"
        >
          Try again
        </Button>
      </div>
    </Layout>
  );
}

ErrorScreen.propTypes = {
};

export default ErrorScreen;
